import type { AgentApiOrganizationsMailSetting } from '@/types/serializers';

export function isMailSenderConfigured(mailSettings: AgentApiOrganizationsMailSetting | null) {
  return (
    (mailSettings?.sender ?? '').trim().length > 0 &&
    (mailSettings?.reply_address ?? '').trim().length > 0 &&
    (mailSettings?.candidate_address_custom_field_id ?? '').trim().length > 0
  );
}
